module.exports = __webpack_public_path__ + "media/images/hero/glyph-a3-acc64db89c775630d0a3deb0fb65dc0e.svg";